/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum JourneyType {
    FlightOnly = 'FlightOnly',
    PackageAndFlight = 'PackageAndFlight'
}

export function JourneyTypeFromJSON(json: any): JourneyType {
    return JourneyTypeFromJSONTyped(json, false);
}

export function JourneyTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): JourneyType {
    return json as JourneyType;
}

export function JourneyTypeToJSON(value?: JourneyType | null): any {
    return value as any;
}

